import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockKeyholeIcon, RepeatIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { Button } from './Button';
import { ProductName } from './ProductName';
import { checkoutUrl, trackCheckout } from '../utils/checkout';
const includes = ['6 complete professional volumes', '150 ready-to-teach pastry lessons', '100% visual teaching material', 'Beginner to advanced progression', 'Step-by-step demonstrations', 'Instructor cues', 'Common mistakes and corrections', 'Student activities', 'Assessments', 'Troubleshooting resources', '5 professional bonus guides', 'Immediate PDF access', '7-day guarantee'];
export function PricingSection() {
  return <section id="pricing" className="bg-blush px-4 py-20 sm:py-28" data-id="element-165" data-mp="2271mrwhg0btz">
      <div className="mx-auto max-w-3xl" data-id="element-166" data-mp="2vqsnfbtoiy5">
        <div className="text-center" data-id="element-167" data-mp="2ws61qgb9hj1">
          <h2 className="font-serif text-4xl font-semibold leading-tight text-espresso sm:text-5xl" data-id="element-168" data-mp="7ta4y9oymlng">
            Your Complete Pastry Teaching System
          </h2>
          <p className="mt-4 text-base leading-7 text-cocoa sm:text-lg" data-id="element-169" data-mp="1mihnyxzrm7w1">
            Everything You Need to Plan Less and Teach With More Structure
          </p>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mt-12 rounded-3xl border border-champagne bg-cream-light p-2 shadow-xl" data-id="element-170" data-mp="1creou1qec2ze">
          <div className="absolute -top-4 left-1/2 inline-flex -translate-x-1/2 items-center gap-1.5 whitespace-nowrap rounded-full border border-champagne bg-champagne-light px-4 py-1.5 text-xs font-bold uppercase tracking-[0.1em] text-espresso" data-id="element-171" data-mp="20emrebwfwxxq">
            <SparklesIcon size={14} className="text-champagne-deep" data-id="element-172" data-mp="k38zf1oedpt8" />
            6-in-1 Visual Teaching System
          </div>
          <div className="rounded-[1.25rem] bg-cream p-6 text-center sm:p-10" data-id="element-173" data-mp="fzb0aqz2of06">
            <ProductName as="h3" className="text-3xl sm:text-4xl" data-id="element-174" data-mp="hj2y71r64dgd" />
            <ul className="mx-auto mt-8 grid max-w-2xl gap-x-6 gap-y-2.5 rounded-2xl border border-champagne bg-cream-light p-5 text-left sm:grid-cols-2" data-id="element-175" data-mp="mhe6v95q8hx0">
              {includes.map(item => <li key={item} className="flex gap-2.5 text-sm leading-6 text-espresso" data-id="element-176" data-mp="ci5gsrdzfnfx">
                  <CheckIcon size={17} className="mt-0.5 shrink-0 text-forest" aria-hidden="true" data-id="element-177" data-mp="3uv3bojvx3q38" />
                  {item}
                </li>)}
            </ul>
            <div className="mt-8" data-id="element-178" data-mp="3px1rtwqo3mqp">
              <span className="block text-base text-cocoa" data-id="element-179" data-mp="3pycwdyrxsyiv">
                Regular Value:{' '}
                <span className="line-through" data-id="element-180" data-mp="3bz3d2q8fpoao">USD $105</span>
              </span>
              <div className="mt-1 flex items-baseline justify-center gap-2" data-id="element-181" data-mp="3fznei601je2m">
                <span className="text-xl font-bold uppercase text-raspberry" data-id="element-182" data-mp="2xatpnhmdiqfe">
                  Today:
                </span>
                <span className="font-serif text-5xl font-semibold text-espresso sm:text-6xl" data-id="element-183" data-mp="2sd1umeqfmo6z">
                  USD $27
                </span>
              </div>
            </div>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="mt-7 w-full sm:w-auto" data-id="element-184" data-mp="31c6srjy30fim">
              GET PASTRY INSTRUCTOR READY NOW
            </Button>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-cocoa" data-id="element-185" data-mp="3b8rzqatnw0p3">
              <span className="flex items-center gap-1.5" data-id="element-186" data-mp="3p43rqagfnd2b">
                <LockKeyholeIcon size={14} className="text-champagne-deep" data-id="element-187" data-mp="3l1z0tjhdcujd" />
                Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-188" data-mp="2syjlx38sr8k">
                <ZapIcon size={14} className="text-champagne-deep" data-id="element-189" data-mp="3u2f1yman3pl2" />
                Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-190" data-mp="hxkqq5j2xstx">
                <RepeatIcon size={14} className="text-champagne-deep" data-id="element-191" data-mp="lywa3tbd1hto" />
                One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}